<template>
  <div>
    <el-card>
      <div class="export-page" v-loading="loadData">
        <!-- 黃單 / 紅單 -->
        <div class="row">
          <el-radio-group v-model="type" size="small" class="ticket-filter">
            <el-radio label="yellow">黃單</el-radio>
            <el-radio label="red">紅單</el-radio>
          </el-radio-group>
        </div>
        <div>
          <el-date-picker
            v-model="date"
            :start-placeholder="$t('chart.date.start')"
            :end-placeholder="$t('chart.date.end')"
            :picker-options="datePickerOptions"
            :default-time="['00:00:00']"
            @change="setDate()"
            type="datetimerange"
            format="yyyy/MM/dd HH:mm"
            size="large"
          />
          <el-button type="primary" 
            :disabled="!selected || loadData" 
            @click="getMessage" 
            style="margin-left:20px"
          >
            搜尋
          </el-button>
        </div>

        <el-cascader
          v-model="selectedInstrumentList"
          style="min-width:200px;margin-top:20px;"
          :options="instrumentOptions"
          :props="props"
          :collapse-tags="true"
          :show-all-levels="false"
          :placeholder="$t('chart.instrument.pick')"
          @change="changeSelectedInstrumentList"
        ></el-cascader>
        <!--div class="row column">
          <label class="txt">選擇要輸出的測站</label>

          <el-select
            v-model="selected"
            placeholder="選擇儀器"
            :disabled="options.length === 0 || loadData"
          >
            <el-option v-for="opt in options" :key="opt" :label="opt" :value="opt" />
          </el-select>
        </div-->

        <!--el-button type="primary" :disabled="!selected || loadData" @click="download">下載</el-button-->

        <table class="file-table">
          <thead>
            <tr>
              <th>編號</th>
              <th>告警儀器</th>
              <th>告警類型</th>
              <th>告警日期</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(alert, i) in alertList" :key="i">
              <td>{{ alert.serialNumber }}</td>
              <td>
                <a href="" @click.prevent="download(alert.instrument,alert.serialNumber,formatDate(alert.startDate))" target="_blank">{{ alert.instrument }}</a>
              </td>
              <th>{{alert.alert_type}}</th>
              <td>{{ formatDate(alert.startDate) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>
    <div class="hidden-chart" ref="chartBox">
      <el-card class="box-card">
        <Chart 
          v-if="useChart"
          :useUrl="this.useUrl"
          :presetDateRange="presetDateRange"
          :presetInstrumentIds="presetInstrumentIds"
          :autoRun="true"
          :autoVelocity1Hr="false"
          @ready="handleChartReady"
        ></Chart>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import Chart from '@/components/chart/index.vue';
import ImageModule from 'docxtemplater-image-module-free';
import JSZip from 'jszip';

export default {
  name: 'TicketExportPage',
  components: {
    //SMS,
    Chart,
  },
  data() {
    return {
      type: 'yellow',
      selected: {},
      date:[
        this.$moment()
          .subtract(6, 'months')
          .startOf('day')
          .valueOf(),
        this.$moment().valueOf(),
      ],
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      alarmsList: [],
      alarmsTypeTable: { yellow: [], red: []},
      instrumentsTable: {},

      useChart: false,
      chartReady: false,
      loadData: false,

      originInstrumentList: [],

      instrumentOptions: [],
      selectedInstrumentList: [],

      props: {
        multiple: true,
        //expandTrigger: 'hover',
        label: 'label',
        value: 'value',
        children: 'children',
      },
    };
  },
  watch: {
    type: 'fetchOptions',
  },
  computed: {
    selectedProject() {
      if(this.project) return this.project;
      return this.$store.getters['project/selectedProject'];
    },
    alertFile() {

      console.log(this.selected);

      let ins_data = this.instrumentsTable[this.selected.selectedInstrument][this.selected.type][this.selected.date];
      let occurrenceOutput = ins_data.occurrenceOutput;
      let getRemark = this.findRangeByDate(ins_data.startDate, ins_data.instrument_data.remark);
      let remark_no = this.formatIndex(getRemark?.index);
      console.log(getRemark);
      let unit = ins_data.instrument_data.data[0].unit;

      return {
        contractor: this.selectedProject.contractor,
        to: '工務所',
        from: this.selectedProject.contractor,
        copy_to: '工程處,監測中心,KMRT/C3C',
        project: this.selectedProject.project_id,
        event_no: !(this.selected.serialNumber) ? `${this.selectedProject.project_id}` : this.selected.serialNumber,
        event_date: ins_data.startDate,
        file_no: (isNaN(remark_no)) ? '' : remark_no,
        //file_page: '1',
        alarms: {
          serialNumber: ins_data.instrument,
          location: ins_data.area,
          measureDate: ins_data.startDate,
          unit,
          measureValue: occurrenceOutput.reading2,
          ALValue: ins_data.AL_config_option.value,
          WSLValue: ins_data.WSL_config_option.value,
          note: getRemark?.item?.content,
        },
      };
    },
    presetInstrumentIds() {
      if(this.selected){
        return [this.instrumentsTable[this.selected.selectedInstrument][this.selected.type][this.selected.date].instrumentId];
      }
      return [];
    },
    presetDateRange() {//['2025-06-17 00:00', '2025-06-21 00:00']
      if(this.selected){
        let occurrenceDate = this.selected.date;
        return [moment(occurrenceDate).subtract(30,'d').format('YYYY-MM-DD HH:mm'), moment(occurrenceDate).add(1,'d').format('YYYY-MM-DD HH:mm')];
      }
      return [moment().subtract(7,'d').format('YYYY-MM-DD HH:mm'), moment().format('YYYY-MM-DD HH:mm')];
    },

    alertList(){
      let st = new Date(this.date[0]).getTime();
      let et = new Date(this.date[1]).getTime();

      let result = this.alarmsTypeTable[this.type].filter(alert=> 
      {
        let t = new Date(alert.startDate).getTime();
        return t >= st && t <= et;
      },
      );

      if(this.selectedInstrumentList.length==0) return result;

      return result.filter(alert=> this.selectedInstrumentList.findIndex( ins => ins[2] === alert.instrument) >= 0);
    },
  },

  async mounted() {
    this.alarmsTypeTable = { yellow: [], red: []};
    this.instrumentsTable = {};
    await this.getInstruments();
    await this.getMessage();
    await this.fetchOptions();
  },

  methods: {
    async fetchOptions() {
      // ★ 依據黃單 / 紅單呼叫 API
      this.selected = {};
      this.options = this.alarmsTypeTable[this.type].map(ele=>ele.instrument);
    },
    download(selectedInstrument,serialNumber, date) {
      
      this.$message.success(`下載 ${this.type === 'yellow' ? '黃單' : '紅單'}：${selectedInstrument}`);
      
      this.selected = {
        selectedInstrument,
        date,
        type: this.type,
        serialNumber,
      };

      this.chartReady = false;
      this.useChart = true;
    },
    setDate(){
      if(this.timeOverThanLimit){
        this.form.interval = 'daily';
      }
    },
    async handleChartReady({ getBase64 }){
      await new Promise((resolve) => setTimeout(resolve, 1000));
      this.chartReady = true;
      this.getBase64 = getBase64;
      this.generateDoc(`${this.type === 'yellow' ? '黃單' : '紅單'}`);
    },

    async getBase64() {
      console.log('there is no function');
    },

    async generateDoc(type) {
      try{
        // 1. 讀取後端範本（二進位 ArrayBuffer）
        console.log(`now fetch ${process.env.VUE_APP_IMAGE_BASE_URL}/template/${type}-template.docx`);
        const res = await fetch(`${process.env.VUE_APP_IMAGE_BASE_URL}/template/${type}-template.docx`);
        if (!res.ok) throw new Error('Template load failed');
        const arrayBuffer = await res.arrayBuffer();

        await this.debugDocx(arrayBuffer);

        // 用 PizZip 解壓
        const zip = new PizZip(arrayBuffer);
        // 用 Docxtemplater 載入模板

        const dataUrl = await this.getBase64();

        console.log('test');
        const imageModule = new ImageModule({
          getImage: (tagValue) => this.base64DataURLToArrayBuffer(tagValue),
          getSize: () => [635, 190],
        });
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
          modules: [imageModule],
        });
        
        // 塞入資料到佔位符
        doc.render({
          contractor: this.alertFile.contractor,
          to: this.alertFile.to,
          from: this.alertFile.from,
          copy_to: this.alertFile.copy_to,
          project: this.alertFile.project,
          event_no: this.alertFile.event_no,
          event_date: this.alertFile.event_date,
          file_no: this.alertFile.file_no,
          //file_page: this.alertFile.file_page,
          // 表格迴圈資料
          alarms: this.alertFile.alarms,
          // 單張圖片
          img:  [ { src: dataUrl } ],
        });

        // 5. 產生新的 .docx Blob
        const outBlob = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });

        // 6. 觸發下載
        saveAs(outBlob, `report_${this.alertFile.file_no}.docx`);
      
        this.useChart = false;
      } catch (e) {
        console.error(e);
        alert('文件產生失敗：' + e.message);
        this.useChart = false;
      }
    },

    async debugDocx(arrayBuffer) {
      const zip = await JSZip.loadAsync(arrayBuffer);
      const xml = await zip.file('word/document.xml').async('string');
      //const bad = xml.match(/{{[^}]{0,7}}}/g);   // 找「被切短」的花括號
      //console.log('可能問題片段:', bad);
      const badOpen = xml.match(/<w:t>{{[^}]*?<\/w:t>/g) || [];
      console.log('開標籤卻沒關的 run (真正問題):', badOpen.slice(0,20));
    },

    base64DataURLToArrayBuffer(dataURL) {
      const base64Regex = /^data:image\/(png|jpg|svg|svg\+xml);base64,/;
      if (!base64Regex.test(dataURL)) {
        return false;
      }
      const stringBase64 = dataURL.replace(base64Regex, '');
      let binaryString;
      if (typeof window !== 'undefined') {
        binaryString = window.atob(stringBase64);
      } else {
        binaryString = new Buffer(stringBase64, 'base64').toString('binary');
      }
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes.buffer;
    },

    getMessage() {
      this.loadData = true;
      this.selected = {};
      return this.$axios({
        category: 'alerts',
        method: 'get',
        apiName: `${this.selectedProject._id}/getAlertsList/ALL`,
      })
        .then(res => {
          let data = res.data.map(ele=>{
            return {
              ...ele,
              startDate: moment(ele.startTime).format('YYYY-MM-DD HH:mm'),
              areaName: ele.area,
              occurrenceDate: ele.startTime,
              AL_config_option: this.getAlertConfigOption(ele.instrument_data, 'AL', ele.rate),
              WSL_config_option: this.getAlertConfigOption(ele.instrument_data, 'WSL', ele.rate),
            };
          });
          //console.log(data);
          this.alarmsList = data;
        
          const alert_type_convert = {
            'AL': 'yellow',
            'WSL': 'red',
          };

          this.alarmsTypeTable = data.reduce((pre,cur)=>{
            if(!alert_type_convert[cur.alert_type]) return pre;
            pre[alert_type_convert[cur.alert_type]].push(cur);
            return pre;
          },{ yellow: [], red: []});

          this.alarmsTypeTable['yellow'] = this.alarmsTypeTable['yellow'].sort((a,b)=>{
            return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
          });
          this.alarmsTypeTable['red'] = this.alarmsTypeTable['red'].sort((a,b)=>{
            return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
          });

          this.instrumentsTable = data.reduce((pre,cur)=>{
            if(!alert_type_convert[cur.alert_type]) return pre;
            
            if(!pre[cur.instrument]){
              pre[cur.instrument] = {
                'yellow':{},
                'red':{},
              };
            }
            pre[cur.instrument][alert_type_convert[cur.alert_type]][this.formatDate(cur.startDate)] = cur;
            return pre;
          },{ });
          this.loadData = false;

          console.log(this.alarmsTypeTable);
        })
        .catch((error)=>{
          this.$notifyError(error);
          console.log(error);
          this.loadData = false;
        });
    },
    getAlertConfigOption(instrument_data, alert_type, rate_type){
      let data = instrument_data?.data[0];
      if(!data) return {};

      if(rate_type) {
        const rateObj = data && data[rate_type] ? data[rate_type] : null;

        const plus_rate  = rateObj ? rateObj[`${alert_type}_plus`]  ?? null : null;
        const minus_rate = rateObj ? rateObj[`${alert_type}_minus`] ?? null : null;
        
        return {
          value: (plus_rate && minus_rate) ? `${plus_rate}/${minus_rate}` : ((plus_rate) ? plus_rate : ((minus_rate) ? minus_rate : '')),
          alert_type,
        };
      }
      let plus  = data[`${alert_type}_plus` ];
      let minus = data[`${alert_type}_minus`];
      return {
        value: (plus && minus) ? `${plus}/${minus}` : ((plus) ? plus : ((minus) ? minus : '')),
        alert_type,
      };
    },

    /**
     * 傳回第一個符合日期的區間物件，以及它在陣列裡的 index
     * @param {string} dateStr - 輸入的日期字串
     * @param {Array<{start_date: string, end_date: string}>} ranges - 區間陣列
     * @returns {{item: object, index: number} | null} - 找到回傳 { item, index }，否則回傳 null
     */
    findRangeByDate(dateStr, ranges) {

      const target = new Date(dateStr).getTime();
      const idx = ranges.findIndex(({ start_date, end_date }) => {
        const start = new Date(start_date).getTime();
        const end   = new Date(end_date).getTime();
        return target >= start && target <= end;
      });

      if (idx !== -1) {
        return {
          item: ranges[idx],
          index: idx,
        };
      }

      return null;
    },
    formatIndex(idx) {
      // +1 再補 0 到 3 碼
      return String(idx + 1).padStart(3, '0');
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      return `${y}/${m}/${d} ${hh}:${mm}`;
    },

    async getInstruments(){
      this.instrumentLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrument/${this.selectedProject._id}`,
      });
      this.originInstrumentList = res.data.reduce((acc,cur)=>{
        cur.data.forEach(ele=>{
          acc.push({
            _id: cur._id,
            name: ele.name,
            area: cur.area,
            station: cur.station,
            startDate: moment(ele.startDate).format('yyyy-MM-DD HH:mm'),
            unit: ele.unit,
            R0: ele.R0,
            offset: ele.offset,
            T0: ele.T0,
            K : ele.K,
            F0: ele.F0,
            F1: ele.F1,
            F2: ele.F2,
            F3: ele.F3,
            F4: ele.F4,
            F5: ele.F5,
            'A+': ele['A+'],
            'A-': ele['A-'],
            WL_plus: ele.WL_plus,
            WL_minus: ele.WL_minus,
            AL_plus: ele.AL_plus,
            AL_minus: ele.AL_minus,
            WSL_plus: ele.WSL_plus,
            WSL_minus: ele.WSL_minus,
            instrument_type: cur.instrument_type,
            timeoutSetting: cur.timeoutSetting,
          });
        });
        return acc;
      },[]);
      
      this.originInstrumentList = this.originInstrumentList.sort((a, b)=>{
        if(a.name === b.name) return a.startDate - b.startDate;
        return a.name - b.name;
      });
      
      this.initCascaderSelector();
      
      this.instrumentLoading = false;
    },

    initCascaderSelector() {
      this.instrumentOptions = [];
      this.selectedInstrumentList = [];

      let areas = {};

      this.originInstrumentList.forEach(ins=>{
        if(areas[ins.area]){
          areas[ins.area].push(ins);
        }
        else areas[ins.area] = [ins];
      });

      let instrumentOptions = [];

      for(let key of Object.keys(areas)){
        areas[key] = areas[key].reduce((acc,cur)=>{
          let index = acc.stations.findIndex(ele => ele.station === cur.station);
          if(index < 0){
            acc.stations.push({
              station: cur.station,
              instruments: [cur],
            });
          }
          else{
            if(acc.stations[index].instruments.findIndex(ele=> ele.name === cur.name) < 0)
              acc.stations[index].instruments.push(cur);
          }
          return acc;
        },{ stations: []});

        instrumentOptions.push({
          label: key,
          //disabled: areas[key].stations.length === 0,
          children: areas[key].stations.map((station)=>{
            return {
              label: station.station,
              //disabled: station.instruments.length === 0,
              children: station.instruments.map(ins=>{
                return {
                  label: ins.name,
                  value: ins.name,
                };
              }),
            };
          }),
        });
      }

      this.instrumentOptions = instrumentOptions;
    },

    changeSelectedInstrumentList() {
      console.log('changeSelectedInstrumentList');
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.export-page {
  background: #fff;
  border-radius: 6px;
}

.export-page .row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;   /* 調整間距 */
}

/* 讓 .row.column 變成縱向排列，且左對齊 */
.export-page .row.column {
  flex-direction: column;
  align-items: flex-start;   /* 寬度依內容，不要被撐滿 */

  .txt {                     /* 標題下方多一點間距 */
    margin: 0 0 8px 0;
  }
}

.hidden-chart {
  position: absolute; 
  top: -9999px; 
  left: -9999px; 
  visibility: hidden;
}

.file-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.file-table th,
.file-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}
</style>
